/** Allowed values for splat `type` in Firestore and forms. */
export const SPLAT_TYPES = [
  'custom',
  'beer_favorite',
  'brewery_favorite',
  'beer_review',
  'brewery_review',
  'beer_checkin',
  'brewery_checkin',
  'completion',
  'first_event_review',
];

/** User-facing labels for splat types. Stored values stay in {@link SPLAT_TYPES}. */
export const SPLAT_TYPE_LABELS = {
  beer_checkin: 'Beer log',
  brewery_checkin: 'Brewery visit log',
};

/**
 * Display label for a splat type. Unknown types render as the stored value.
 *
 * @param {unknown} type
 * @returns {string}
 */
export function getSplatTypeLabel(type) {
  const trimmed = type == null ? '' : String(type).trim();
  if (!trimmed) {
    return 'custom';
  }
  return Object.prototype.hasOwnProperty.call(SPLAT_TYPE_LABELS, trimmed)
    ? SPLAT_TYPE_LABELS[trimmed]
    : trimmed;
}

/**
 * Deduplicate and sort splat ids for `completionSplatIds` (set semantics; stable storage).
 *
 * @param {unknown} ids
 * @returns {string[]}
 */
export function normalizeCompletionSplatIds(ids) {
  if (!Array.isArray(ids)) return [];
  const seen = new Set();
  for (const id of ids) {
    const trimmedId = String(id ?? '').trim();
    if (trimmedId) seen.add(trimmedId);
  }
  return [...seen].sort((a, b) => a.localeCompare(b));
}

/**
 * Normalize and validate a splat `type` against {@link SPLAT_TYPES}.
 * Empty or whitespace-only input becomes `custom`.
 *
 * @param {string | null | undefined} type
 * @returns {string | null} Canonical allowed type, or `null` if not allowed
 */
export function validateSplatType(type) {
  const trimmed =
    type == null || String(type).trim() === ''
      ? 'custom'
      : String(type).trim();
  return SPLAT_TYPES.includes(trimmed) ? trimmed : null;
}
